import classNames from 'classnames';
import styles from './typography.module.scss';

type TextComponents = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'label';
type Variants =
    | 'heading1'
    | 'heading2'
    | 'heading3'
    | 'heading4'
    | 'body'
    | 'bodyBold'
    | 'small1'
    | 'small2';

interface TypographyProps extends React.HTMLAttributes<HTMLElement> {
    component?: TextComponents;
    variant?: Variants;
    children?: React.ReactNode;
    color?: 'primary' | 'secondary';
}

export const Typography = ({
    component = 'p',
    variant = 'body',
    color = 'primary',
    children,
    ...props
}: TypographyProps) => {
    const Component = component;
    return (
        <Component {...props} className={classNames([styles[variant], styles[color], props.className])}>
            {children}
        </Component>
    );
};
